import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import RadioButtonUncheckedRoundedIcon from "@mui/icons-material/RadioButtonUncheckedRounded";
import { Box, Button, Card, CardContent, Chip, LinearProgress, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../i18n";

export default function SetupChecklist({ steps = [] }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const complete = steps.filter((step) => step.complete).length;
  const total = steps.length || 1;
  const percentage = Math.round((complete / total) * 100);

  return (
    <Card sx={{ height: "100%", borderRadius: 4 }}>
      <CardContent sx={{ p: { xs: 2.5, md: 3 } }}>
        <Stack direction="row" justifyContent="space-between" gap={2} alignItems="flex-start">
          <Box>
            <Typography variant="h6">{t("dashboard.storeSetup")}</Typography>
            <Typography color="text.secondary" variant="body2" sx={{ mt: 0.45 }}>
              {t("dashboard.setupHelp")}
            </Typography>
          </Box>
          <Chip
            label={t("dashboard.complete", { done: complete, total: steps.length })}
            color={percentage === 100 ? "success" : "primary"}
            variant="outlined"
            size="small"
          />
        </Stack>

        <LinearProgress
          variant="determinate"
          value={percentage}
          color={percentage === 100 ? "success" : "primary"}
          sx={{ mt: 2.25, mb: 2.5, height: 8, borderRadius: 999, bgcolor: "#e2e8f0" }}
        />

        <Stack spacing={1.1}>
          {steps.map((step) => (
            <Box
              key={step.label}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.35,
                p: 1.35,
                borderRadius: 2.5,
                border: "1px solid",
                borderColor: step.complete ? "#bbf7d0" : "#e2e8f0",
                bgcolor: step.complete ? "#f0fdf4" : "#fff",
              }}
            >
              {step.complete ? (
                <CheckCircleRoundedIcon color="success" fontSize="small" />
              ) : (
                <RadioButtonUncheckedRoundedIcon sx={{ color: "#94a3b8" }} fontSize="small" />
              )}
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography fontWeight={850} variant="body2">
                  {step.label}
                </Typography>
                <Typography color="text.secondary" variant="caption" display="block" noWrap>
                  {step.description}
                </Typography>
              </Box>
              {!step.complete && step.path && (
                <Button
                  size="small"
                  endIcon={<ArrowForwardRoundedIcon />}
                  onClick={() => navigate(step.path)}
                  sx={{ minWidth: 0, px: 1.1 }}
                >
                  {t("dashboard.open")}
                </Button>
              )}
            </Box>
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
}
